import React from 'react';
import VendorOnboardingLayout from './VendorOnboardingLayout';
import './vendorOnboarding.css';

const VendorOnboardingSubmitted = ({ isEdit = false, pendingApproval = false }) => {
  const title = isEdit ? 'Vendor Edition' : 'Vendor Onboarding';
  const successMessage = pendingApproval
    ? 'Your details have been submitted and are pending finance approval.'
    : isEdit
      ? 'Your vendor edition form has been submitted successfully.'
      : 'Your vendor onboarding form has been submitted successfully.';

  return (
    <VendorOnboardingLayout title={title}>
      <div className="vendor-onboarding-success">
        <div className="vendor-onboarding-success-icon">&#10003;</div>
        <h5>{successMessage}</h5>
        <p className="vendor-onboarding-success-note">
          You may close this window. Our team will review your submission and contact you if needed.
        </p>
      </div>
    </VendorOnboardingLayout>
  );
};

export default VendorOnboardingSubmitted;
